module.exports = __webpack_public_path__ + "static/img/joinBanner4.bf9d833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/join/joinBanner4.jpg
// module id = Eto4
// module chunks = 0